import { axios } from '@util'

class Downloads {
  async getDownloads(params = {}) {
    return await axios({
      url: '/downloaded_reports',
      params: params
    })
  }
}

export default new Downloads()
